import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  IconButton,
  FormControlLabel,
  Switch,
  TextField,
  MenuItem,
  Chip,
  Button,
  Box,
  Alert,
  Divider,
} from "@mui/material";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { useTenant } from "../context/TenantContext";
import { PageHeader } from "../components/PageHeader";

export function ReportSchedule() {
  const { tenant } = useTenant();
  const [active, setActive] = useState(true);
  const [frequency, setFrequency] = useState("diario");
  const [hour, setHour] = useState("08:00");
  const [useKeycloak, setUseKeycloak] = useState(true);
  const [recipients, setRecipients] = useState<string[]>([]);
  const [newPhone, setNewPhone] = useState("");

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <IconButton component={RouterLink} to="/relatorios" size="small">
          <ArrowBackRoundedIcon fontSize="small" />
        </IconButton>
        <Typography variant="body2" color="text.secondary">Relatórios</Typography>
      </Stack>

      <PageHeader
        title="Configurar envio"
        subtitle={<>Cronjob automático via WhatsApp para <strong>{tenant ?? "?"}</strong></>}
      />

      <Card variant="outlined">
        <CardContent>
          <Stack spacing={3} divider={<Divider flexItem />}>
            <FormControlLabel
              control={<Switch checked={active} onChange={(e) => setActive(e.target.checked)} />}
              label={<Box><Typography variant="subtitle2">Envio automático</Typography><Typography variant="caption" color="text.secondary">Cronjob roda em produção</Typography></Box>}
            />

            <TextField
              select
              label="Frequência"
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
              fullWidth
            >
              <MenuItem value="diario">Diária (dias úteis)</MenuItem>
              <MenuItem value="semanal">Semanal (segundas)</MenuItem>
              <MenuItem value="mensal">Mensal (dia 1)</MenuItem>
            </TextField>

            <Stack direction="row" spacing={2} alignItems="center">
              <TextField label="Horário" value={hour} onChange={(e) => setHour(e.target.value)} sx={{ maxWidth: 140 }} />
              <Typography variant="caption" color="text.secondary">América/São_Paulo</Typography>
            </Stack>

            <Box>
              <Typography variant="subtitle2" gutterBottom>Destinatários</Typography>
              <FormControlLabel
                control={<Switch checked={useKeycloak} onChange={(e) => setUseKeycloak(e.target.checked)} />}
                label="Usar contatos do Keycloak (recomendado)"
              />
              {useKeycloak && (
                <Alert severity="info" sx={{ mt: 1, borderRadius: 2 }}>
                  Todos usuários de <strong>{tenant}</strong> com telefone verificado no Keycloak recebem o envio.
                </Alert>
              )}

              <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 2, mb: 1 }}>
                {recipients.map((p) => (
                  <Chip key={p} label={p} onDelete={() => setRecipients((prev) => prev.filter((x) => x !== p))} />
                ))}
              </Stack>

              <Stack direction="row" spacing={1}>
                <TextField
                  label="+55 85 9****-1234"
                  size="small"
                  value={newPhone}
                  onChange={(e) => setNewPhone(e.target.value)}
                  sx={{ maxWidth: 260 }}
                />
                <Button
                  startIcon={<AddCircleOutlineRoundedIcon />}
                  variant="outlined"
                  onClick={() => {
                    if (newPhone.trim()) {
                      setRecipients((prev) => [...prev, newPhone.trim()]);
                      setNewPhone("");
                    }
                  }}
                >
                  Adicionar
                </Button>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Fluxo de gravação (POST /api/reports/schedule) ainda não implementado — este formulário mostra
        o que já roda hoje via cronjob no cluster owlia (agendado em <code>infra/apps/*/cronjobs.yaml</code>).
      </Alert>
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button component={RouterLink} to="/relatorios" variant="text">Cancelar</Button>
        <Button variant="contained" disabled>Salvar agendamento</Button>
      </Stack>
    </>
  );
}
